import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "status"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_GradientText = _resolveComponent("GradientText")
  const _component_UploadItem = _resolveComponent("UploadItem")
  const _component_VirtualScroller = _resolveComponent("VirtualScroller")
  const _component_Segment = _resolveComponent("Segment")
  const _component_Panel = _resolveComponent("Panel")

  return (_openBlock(), _createBlock(_component_Panel, {
    class: "panel",
    collapsed: $data.collapsed,
    onClick: _cache[4] || (_cache[4] = $event => ($data.collapsed = !$data.collapsed))
  }, {
    header: _withCtx(() => [
      ($props.expanded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_GradientText, {
              class: _normalizeClass(["progress", {chosen: $data.filter === undefined}]),
              hoverable: $data.filter !== undefined,
              onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($data.filter = undefined), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Uploaded: " + _toDisplayString(_ctx.$utils.str.pluralize($options.done.length, `/ ${$props.uploads.length} item`)), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["hoverable", "class"]),
            (!!$options.active.length)
              ? (_openBlock(), _createBlock(_component_GradientText, {
                  key: 0,
                  class: _normalizeClass(["active", {chosen: $data.filter === 'active'}]),
                  hoverable: $data.filter !== 'active',
                  onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($data.filter = 'active'), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Active: " + _toDisplayString($options.active.length), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["hoverable", "class"]))
              : _createCommentVNode("v-if", true),
            (!!$options.failed.length)
              ? (_openBlock(), _createBlock(_component_GradientText, {
                  key: 1,
                  class: _normalizeClass(["failed", {chosen: $data.filter === 'failed'}]),
                  hoverable: $data.filter !== 'failed',
                  onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($data.filter = 'failed'), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Failed: " + _toDisplayString($options.failed.length), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["hoverable", "class"]))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(`Uploading ${_ctx.$utils.str.pluralize($props.uploads.length, 'item')}`), 1 /* TEXT */)
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Segment, { class: "list" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "panel-content",
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(_component_VirtualScroller, {
              ref: "scroller",
              items: $options.v_items,
              "node-padding": 5
            }, {
              default: _withCtx(({item}) => [
                (_openBlock(), _createBlock(_component_UploadItem, {
                  id: item.id,
                  ref: "items",
                  key: item.id,
                  instance: item,
                  grid_cols: "26rem 1fr auto",
                  onDelete: $event => (_ctx.$emit('delete', item.id))
                }, null, 8 /* PROPS */, ["id", "instance", "onDelete"]))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["items"])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["collapsed"]))
}